import {
  STATUS_TYPES,
  StatusKey,
} from "../../../utils/integrationConfigData";

interface StatusBadgeProps {
  status: StatusKey | string;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const statusKey =
    (status as StatusKey) in STATUS_TYPES ? (status as StatusKey) : "notSet";
  const statusMeta = STATUS_TYPES[statusKey];

  return (
    <span
      className={`ic-status-badge ic-status-${statusMeta.tone} ic-status-key-${statusKey}`}
    >
      <i className={`ic-status-icon ${statusMeta.icon}`} aria-hidden="true"></i>
      {statusMeta.label}
    </span>
  );
};

export default StatusBadge;
